@if (ready()) {
  @for (hit of hits(); track hit.objectID) {
    <app-wine-festival-product [hit]="hit"/>
  }
  <div #bottomElement></div>
  @if (!state()?.isLastPage) {
    <app-loading-icon/>
  }
}
